import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.slide-show').length) {

	$('.slideshow-swiper').each(function() {
		var swiper = new Swiper(this, {
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			loop: true,
			speed: 500,
		});

		var $parent = $(this).parent();

		$parent.find('.next').on('click', function() {
			swiper.slideNext(500);
		});

		$parent.find('.prev').on('click', function() {
			swiper.slidePrev(500);
		});
	});

}
